module.exports = __webpack_public_path__ + "static/media/x43mk2-logo.6880799c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/X43MK2/x43mk2-logo.svg
// module id = 385
// module chunks = 0